module.exports = __webpack_public_path__ + "img/logo_transparent.e4cc2d4e.png";